import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { AuthService } from '../../../services/auth/auth.service';
import { UserService } from '../../../services/user/user.service';
import { MessageModalService } from '../../../services/message-modal/message-modal.service';

import { TemplatePasswordComponent } from '../../../shared/template-password/template-password.component';
import { ModalDialogComponent } from '../../../shared/modal-dialog/modal-dialog.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, TemplatePasswordComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css',
})
export class ChangePasswordComponent {
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private location: Location,
    private userService: UserService,
    private authService: AuthService,
    private messageModal: MessageModalService
  ) {}
  title = $localize`Change Password`;
  desc = $localize`Enter the new password for your account.`;

  handleSave(event: any) {
    const email = this.userService.user?.email ?? null;
    const newPassword = event.newPassword;
    const oldPassword = event.existPassword;

    if (email) {
      this.authService.changePassword({ email, newPassword, oldPassword }).subscribe({
        next: (response) => {
          if (response.success) {
            this.successDialog();
          } else {
            this.messageModal.openModal($localize`Error`, $localize`${response.message}`);
          }
        },
        error: (err) => {
          console.error(err);
          this.messageModal.openModal($localize`Error`, $localize`Current password does not match.`);
        },
      });
    }
  }

  handleCancel() {
    this.location.back();
  }

  successDialog() {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      width: '50rem',
      data: {
        title: $localize`Success`,
        description: $localize`Password has been successfully changed.`,
        primaryButtonLabel: $localize`OK`,
        secondaryButtonLabel: $localize`Cancel`,
        showPrimaryButton: true, // Show primary button
        showSecondaryButton: false, // Secondary button is always shown
      },
    });

    dialogRef.componentInstance.primaryAction.subscribe(() => {
      this.router.navigate(['/login']);
      dialogRef.close(true);
    });
  }
}
